import PropTypes from 'prop-types'
import useTranslations from '../../../i18n/useTranslations'

import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'

const EnhancedTableHead = ({ headCells, order, orderBy, onRequestSort }) => {
  const t = useTranslations()
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => {
          const label = t(`noun:${headCell.id}`)
          if (headCell.id === 'loading' || headCell.id === 'actionButtons') return <TableCell className={headCell.extraClass} key={headCell.id} />
          return (
            <TableCell
              key={headCell.id}
              className={headCell.extraClass}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.sortable ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                  style={
                    {
                      // color: orderBy === headCell.id ? '#DF0024' : '',
                    }
                  }
                >
                  {label}
                </TableSortLabel>
              ) : (
                label
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  headCells: PropTypes.array.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
}

export default EnhancedTableHead
